module.exports = __webpack_public_path__ + "static/media/earning_icon.c6f7058a.svg";